const STORAGE_KEY = 'portal_return_to';

export function isSafeReturnTo(value: string | null | undefined): value is string {
  return !!value && value.startsWith('/') && !value.startsWith('//') && !value.includes('://');
}

export function storeReturnTo(value: string | null | undefined): void {
  if (!isSafeReturnTo(value)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, value);
  } catch {
    // ignore quota / private mode
  }
}

export function takeReturnTo(): string | null {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);
    if (value) sessionStorage.removeItem(STORAGE_KEY);
    return isSafeReturnTo(value) ? value : null;
  } catch {
    return null;
  }
}

export function clearReturnTo(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
